import React from "react";
import { Deck } from "spectacle";
import theme from "./theme";
import title from "./slides/title";
import functions from "./slides/functions";
import algorithm from "./slides/algorithm";
import complex from "./slides/complex";
import complexFunction from "./slides/complexFunction";
import fractal from "./slides/fractal";
import "normalize.css";

const slides = [
  ...title,
  ...functions,
  ...algorithm,
  ...complex,
  ...complexFunction,
  ...fractal
];

export default class Presentation extends React.Component {
  render() {
    return (
      <Deck theme={theme} contentWidth={1200} contentHeight={850}>
        {slides.map((e, i) => React.cloneElement(e, { key: i }))}
      </Deck>
    );
  }
}
